/**
 * Imports a CSS file that has global effect, e.g. reset, fonts, in a
 * consistent order. Import this as the first line in an entry point.
 */
/* tslint:disable:no-import-side-effect */
import './reset.css';

// Reduced to one file in order to fix/workaround/prevent case where despite
// the dev build working to produce the right output
// the prodsim build did not apply the (two) files in the right order ?



// WEBPACK FOOTER //
// ./src/ui/common/init-global-css.ts